import { mount } from 'svelte';
// The stylesheets index.html used to load from CDNs (the same files, now from npm), in the same order, then the
// theme and the app's styles, before the components' styles. Two Bootstrap versions on purpose, for now:
// Bootstrap 5.2.0-beta1 here and 5.1.3 inside the SB Admin theme (styles.css); see docs/modernization.md, phase 5.
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fontsource/source-sans-pro/400.css';
import '@fontsource/source-sans-pro/600.css';
import '@fontsource/source-sans-pro/700.css';
// the CSS (web font) only: Font Awesome's JS build re-scans the page on every DOM change
import '@fortawesome/fontawesome-free/css/all.min.css';
import './styles/styles.css';
import './styles/global.css';
import './styles/validation.css';
// Bootstrap's dropdowns (data-bs-toggle="dropdown"): the only part of Bootstrap's script the app uses
import 'bootstrap/js/dist/dropdown';
import { startMocks } from 'virtual:sensay-dev-mocks';
import App from './App.svelte';
import { configureTransport } from './api/transport';
import { ANALYTICS_ENABLED, API_BASE_URL } from './config.js';
import { startI18n } from './i18n/index.js';
import { configureAnalytics } from './utils/analytics.js';
import { loadAnalyticsVendors } from './utils/analyticsVendors.js';
import { logout } from './utils/ApiUtils.svelte';

configureAnalytics({ enabled: ANALYTICS_ENABLED });
// the generated API clients end the session the way the rest of the app does
configureTransport({ onSessionEnded: logout });
if (ANALYTICS_ENABLED) {
  loadAnalyticsVendors();
}

// mounted once the first dictionary is there, so the first render is already translated (and, in mocked
// development, once the mocked API answers, before the app's first call)
(startMocks ? startMocks({ apiBaseUrl: API_BASE_URL }) : Promise.resolve())
  .then(() => startI18n())
  .then(() => mount(App, { target: document.body }));
